import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "as-shooting__top" }
const _hoisted_3 = { class: "as-shooting__table" }
const _hoisted_4 = { class: "as-shooting__table-row as-shooting__table-row-head" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "as-shooting__table-column as-shooting__table-column-player" }
const _hoisted_7 = { class: "as-shooting__player" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "as-shooting__player-content" }
const _hoisted_10 = { class: "as-shooting__player-name" }
const _hoisted_11 = { class: "as-shooting__player-detail" }
const _hoisted_12 = { class: "as-start" }
const _hoisted_13 = { class: "as-position" }
const _hoisted_14 = {
  key: 0,
  class: "as-shooting__player-name"
}
const _hoisted_15 = {
  key: 0,
  class: "as-position"
}
const _hoisted_16 = {
  key: 1,
  class: "as-position"
}

import { ref, computed } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import NoData from "~src/components/NoData.vue";
import type {
  IMatch,
  IRecent,
  IPlayerDataShooting,
} from "~src/interfaces//basketball";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { mapPlayer } from "~src/helpers/basketball";
import TabsBtn from "~src/components/TabsBtn.vue";


const __default__ = {};

interface IProps {
  isPopup: boolean;
  shooting: any;
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ShootingListTab',
  props: {
    isPopup: { type: Boolean, default: true },
    shooting: {},
    match: {}
  },
  setup(__props: any) {

const props = __props;

const isShowFull = ref(false);
const activeTab = ref("all");
const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: props.shooting?.match?.home_team?.name || "Home Team",
    key: "home",
  },
  {
    title: props.shooting?.match?.away_team?.name || "Away Team",
    key: "away",
  },
]);

const columns = [
  {
    title: "Cầu thủ",
    name: "player_name",
    class: "as-shooting__table-column-player as-column-head",
  },
  {
    title: "MIN",
    name: "min",
    class: "as-text-center",
  },
  {
    title: "PTS",
    name: "pts",
    class: "as-text-center as-c-total",
  },
  {
    title: "REB",
    name: "reb",
    class: "as-text-center as-c-w",
  },
  {
    title: "AST",
    name: "ast",
    class: "as-text-center as-c-d",
  },
  {
    title: "BLK",
    name: "blk",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "STL",
    name: "stl",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "FG",
    name: "fg",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "3PT",
    name: "3pt",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "FT",
    name: "ft",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "OREB",
    name: "oreb",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "DREB",
    name: "dreb",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "TOV",
    name: "tov",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "A/T",
    name: "at",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "PF",
    name: "pf",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "+/-",
    name: "+/-",
    class: "as-text-center as-coulumn-show-full",
  },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const changeTab = (val: string) => {
  activeTab.value = val;
};

const rows = computed(() => {
  let rows = [];

  const lineup = props?.shooting?.lineup;
  const playersHomeTeam = lineup?.players[0] || [];
  const playersAwayTeam = lineup?.players[1] || [];
  const allPlayers = [...playersHomeTeam, ...playersAwayTeam];
  let allPlayersLineup = [];
  if (!lineup) {
    allPlayersLineup = [];
  } else {
    let { home_team_squad, away_team_squad, players } = lineup;
    if (!home_team_squad) {
      home_team_squad = {
        squad: [],
      };
    }

    if (!away_team_squad) {
      away_team_squad = {
        squad: [],
      };
    }
    const allPlayersLineup = [
      ...home_team_squad?.squad,
      ...away_team_squad?.squad,
    ];
  }

  for (const row of allPlayers) {
    const currentPlayerInfo = row[4].split("^");
    const hitsShots = currentPlayerInfo[1].split("-"); // "8-12" -> 8 successful shots
    const threePointers = currentPlayerInfo[2].split("-"); // "2-3" -> 2 successful three-pointers
    const freeThrows = currentPlayerInfo[3].split("-"); // "1-1" -> 1 successful free throw

    // Calculate two-pointers by subtracting three-pointers from total field goals
    const twoPointersMade = hitsShots[0] - threePointers[0];
    const threePointersMade = parseInt(threePointers[0], 10);
    const freeThrowsMade = parseInt(freeThrows[0], 10);

    // Calculate total points
    const totalPoint =
      twoPointersMade * 2 + threePointersMade * 3 + freeThrowsMade * 1;

    const isHome = playersHomeTeam.some((item: any) => item[0] === row[0]);
    rows.push({
      ...row,
      id: row[0],
      positionGame: mapPlayer(row[0], props?.shooting?.listPlayer)?.position
        ?.position,
      player_name: row[1],
      logo: row[2],
      reb: parseInt(currentPlayerInfo[6]) || 0,
      ast: parseInt(currentPlayerInfo[7]) || 0,
      min: parseInt(currentPlayerInfo[0]) || 0,
      blk: parseInt(currentPlayerInfo[9]) || 0,
      stl: parseInt(currentPlayerInfo[8]) || 0,
      fg: currentPlayerInfo[1] || "0-0",
      "3pt": currentPlayerInfo[2] || "0-0",
      starter: parseInt(currentPlayerInfo[16]) === 0 ? "Starter" : "",
      teamId: isHome ? 1 : 2,
      totalPoint,
      oreb: currentPlayerInfo[4],
      dreb: currentPlayerInfo[5],
      tov: currentPlayerInfo[10],
      ft: currentPlayerInfo[3],
      "+/-": currentPlayerInfo[12],
      at:
        currentPlayerInfo[10] > 0
          ? (
              (parseInt(currentPlayerInfo[7]) || 0) / currentPlayerInfo[10]
            ).toFixed(2)
          : 0,
      pf: currentPlayerInfo[11],
    });
  }
  if (rows.length === 0) {
    if (!lineup) {
      return [];
    }
    const { home_team_squad, away_team_squad, players } = lineup;
    const homePlayers = home_team_squad?.squad.map((player: any) => {
      const currentPlayer = allPlayers.find((item) => {
        return item[0] == player?.player?.id;
      });
      const currentPlayerInfo = currentPlayer
        ? currentPlayer[4].split("^")
        : [];
      if (currentPlayer) {
      }
      return {
        id: player?.player?.id,
        positionGame: player?.position,
        teamId: 1,
        player_name:
          player?.player?.name ||
          mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.name,
        logo: mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.logo,
        totalPoint: 0,
        reb: parseInt(currentPlayerInfo[6]) || 0,
        ast: parseInt(currentPlayerInfo[7]) || 0,
        min: parseInt(currentPlayerInfo[0]) || 0,
        blk: parseInt(currentPlayerInfo[9]) || 0,
        stl: parseInt(currentPlayerInfo[8]) || 0,
        "3pt": parseInt(currentPlayerInfo[2]?.split("-")?.[0]) || 0,
        starter: parseInt(currentPlayerInfo[16]) === 0 ? "Starter" : "",
        dreb: currentPlayerInfo[5],
        tov: currentPlayerInfo[10],
        ft: currentPlayerInfo[3],
        "+/-": currentPlayerInfo[12],
        at:
          currentPlayerInfo[10] > 0
            ? (
                (parseInt(currentPlayerInfo[7]) || 0) / currentPlayerInfo[10]
              ).toFixed(2)
            : 0,
        pf: currentPlayerInfo[11],
      };
    });
    const awayPlayers = away_team_squad?.squad.map((player: any) => {
      const currentPlayer = allPlayers.find(
        (item) => item[0] === player?.player?.id
      );
      const currentPlayerInfo = currentPlayer
        ? currentPlayer[4].split("^")
        : [];
      return {
        id: player?.player?.id,
        positionGame: player?.position,
        teamId: 2,
        player_name:
          player?.player?.name ||
          mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.name,
        logo: mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.logo,
        totalPoint: 0,
        reb: parseInt(currentPlayerInfo[6]) || 0,
        ast: parseInt(currentPlayerInfo[7]) || 0,
        min: parseInt(currentPlayerInfo[0]) || 0,
        blk: parseInt(currentPlayerInfo[9]) || 0,
        stl: parseInt(currentPlayerInfo[8]) || 0,
        "3pt": parseInt(currentPlayerInfo[2]?.split("-")?.[0]) || 0,
        starter: parseInt(currentPlayerInfo[16]) === 0 ? "Starter" : "",
        dreb: currentPlayerInfo[5],
        tov: currentPlayerInfo[10],
        ft: currentPlayerInfo[3],
        "+/-": currentPlayerInfo[12],
        at:
          currentPlayerInfo[10] > 0
            ? (
                (parseInt(currentPlayerInfo[7]) || 0) / currentPlayerInfo[10]
              ).toFixed(2)
            : 0,
        pf: currentPlayerInfo[11],
      };
    });
    rows = [...homePlayers, ...awayPlayers];
  }
  if (activeTab.value === "all") {
    rows = rows.sort((a: any, b: any) => {
      return b.totalPoint > a.totalPoint ? 1 : -1;
    });
    return rows;
  }
  rows = rows
    .filter((row) => {
      if (activeTab.value === "home") {
        return row.teamId === 1;
      } else {
        return row.teamId === 2;
      }
    })
    .map((item, index) => {
      return {
        ...item,
        position: index + 1,
      };
    });
  rows?.sort((a: any, b: any) => {
    if (activeTab.value === "home") {
      // chọn sắp xếp
      if (sort.value.column) {
        // sắp xếp string
        if (sort.value.column === "player_name") {
          if (sort.value.type === "DESC") {
            return a.player_name.localeCompare(b.player_name);
          } else {
            return b.player_name.localeCompare(a.player_name);
          }
        } else if (sort.value.column === "position") {
          if (sort.value.type === "DESC") {
            return a.position - b.position;
          } else {
            return b.position - a.position;
          }
        } else if (sort.value.column === "pts") {
          if (sort.value.type === "DESC") {
            return a.totalPoint - b.totalPoint;
          } else {
            return b.totalPoint - a.totalPoint;
          }
        } else if (sort.value.column === "reb") {
          if (sort.value.type === "DESC") {
            return a.reb - b.reb;
          } else {
            return b.reb - a.reb;
          }
        } else if (sort.value.column === "ast") {
          if (sort.value.type === "DESC") {
            return a.ast - b.ast;
          } else {
            return b.ast - a.ast;
          }
        } else if (sort.value.column === "blk") {
          if (sort.value.type === "DESC") {
            return a.blk - b.blk;
          } else {
            return b.blk - a.blk;
          }
        } else if (sort.value.column === "stl") {
          if (sort.value.type === "DESC") {
            return a.stl - b.stl;
          } else {
            return b.stl - a.stl;
          }
        } else if (sort.value.column === "min") {
          if (sort.value.type === "DESC") {
            return a.min - b.min;
          } else {
            return b.min - a.min;
          }
        } else if (sort.value.column === "fg") {
          if (sort.value.type === "DESC") {
            return a.fg - b.fg;
          } else {
            return b.fg - a.fg;
          }
        } else if (sort.value.column === "3pt") {
          if (sort.value.type === "DESC") {
            return a["3pt"] - b["3pt"];
          } else {
            return b["3pt"] - a["3pt"];
          }
        } else if (sort.value.column === "oreb") {
          if (sort.value.type === "DESC") {
            return a.oreb - b.oreb;
          } else {
            return b.oreb - a.oreb;
          }
        } else if (sort.value.column === "min") {
          if (sort.value.type === "DESC") {
            return a.min - b.min;
          } else {
            return b.min - a.min;
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return a.totalPoint > b.totalPoint ? -1 : 1;
      }
    }

    if (activeTab.value === "away") {
      if (sort.value.column) {
        if (sort.value.column === "player_name") {
          if (sort.value.type === "DESC") {
            return a.player_name.localeCompare(b.player_name);
          } else {
            return b.player_name.localeCompare(a.player_name);
          }
        } else if (sort.value.column === "position") {
          if (sort.value.type === "DESC") {
            return a.position - b.position;
          } else {
            return b.position - a.position;
          }
        } else if (sort.value.column === "pts") {
          if (sort.value.type === "DESC") {
            return a.totalPoint - b.totalPoint;
          } else {
            return b.totalPoint - a.totalPoint;
          }
        } else if (sort.value.column === "reb") {
          if (sort.value.type === "DESC") {
            return a.reb - b.reb;
          } else {
            return b.reb - a.reb;
          }
        } else if (sort.value.column === "ast") {
          if (sort.value.type === "DESC") {
            return a.ast - b.ast;
          } else {
            return b.ast - a.ast;
          }
        } else if (sort.value.column === "blk") {
          if (sort.value.type === "DESC") {
            return a.blk - b.blk;
          } else {
            return b.blk - a.blk;
          }
        } else if (sort.value.column === "stl") {
          if (sort.value.type === "DESC") {
            return a.stl - b.stl;
          } else {
            return b.stl - a.stl;
          }
        } else if (sort.value.column === "fg") {
          if (sort.value.type === "DESC") {
            return a.fg - b.fg;
          } else {
            return b.fg - a.fg;
          }
        } else if (sort.value.column === "3pt") {
          if (sort.value.type === "DESC") {
            return a["3pt"] - b["3pt"];
          } else {
            return b["3pt"] - a["3pt"];
          }
        } else if (sort.value.column === "oreb") {
          if (sort.value.type === "DESC") {
            return a.oreb - b.oreb;
          } else {
            return b.oreb - a.oreb;
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return a.totalPoint > b.totalPoint ? -1 : 1;
      }
    }
  });
  return rows;
});

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const getRowdata = (row: IPlayerDataShooting, field: string) => {
  if (field === "pts") {
    return row.totalPoint || 0;
  } else if (field === "reb") {
    return row.reb || 0;
  } else if (field === "ast") {
    return row.ast || 0;
  } else if (field === "min") {
    return row.min || 0;
  } else if (field === "blk") {
    return row.blk || 0;
  } else if (field === "stl") {
    return row.stl || 0;
  } else if (field === "fg") {
    return row.fg || 0;
  } else if (field === "3pt") {
    return row["3pt"] || 0;
  } else if (field === "oreb") {
    return row.oreb || 0;
  } else if (field === "dreb") {
    return row.dreb || 0;
  } else if (field === "ft") {
    return row.ft || 0;
  } else if (field === "tov") {
    return row.tov || 0;
  } else if (field === "at") {
    return row.at || 0;
  } else if (field === "pf") {
    return row.pf || 0;
  } else if (field === "+/-") {
    return row["+/-"] || 0;
  }
};

const getRecentTitle = (recent: IRecent) => {
  return `${recent.home_scores[0]}:${recent.away_scores[0]} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

const setAsRowActive = (column: string = "") => {
  if (sort.value.column === column) {
    return "as-row-active";
  }

  return "";
};

return (_ctx: any,_cache: any) => {
  return (rows.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TabsBtn, {
            tabs: tabs.value,
            activeTab: activeTab.value,
            onChange: changeTab,
            isShowBorder: true
          }, null, 8, ["tabs", "activeTab"]),
          _createElementVNode("div", {
            class: _normalizeClass(["as-menu", {
          'as-active': isShowFull.value,
        }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowFull.value = !isShowFull.value))
          }, [
            _createVNode(IconMenu)
          ], 2)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["as-shooting", {
        [`as-shooting-${_ctx.gSiteName}`]: true,
        'as-show-full': isShowFull.value,
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
          _ctx.isPopup,
      }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                return _createElementVNode("div", {
                  key: column.name,
                  onClick: ($event: any) => (sortData(column.name)),
                  class: _normalizeClass([
              `as-shooting__table-column ${column.class}`,
              {
                'as-row-active': sort.value.column === column.name,
              },
            ]),
                  type: "button"
                }, [
                  _createTextVNode(_toDisplayString(column.title) + " ", 1),
                  (sort.value.column === column.name)
                    ? (_openBlock(), _createBlock(IconArrownDown, {
                        key: 0,
                        class: _normalizeClass(["as-d-inline-flex", {
                'as-sort-down': sort.value.type === 'ASC',
                'as-sort-up': sort.value.type === 'DESC',
              }])
                      }, null, 8, ["class"]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5)
              }), 64))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row, keyRow) => {
              return (_openBlock(), _createElementBlock("div", {
                key: keyRow,
                class: "as-shooting__table-row"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrlBySport('player', row.id),
                      class: "as-shooting__player-logo",
                      alt: row.player_name
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(row.player_name), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(row.starter), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(row?.positionGame || ""), 1)
                      ]),
                      (activeTab.value === 'all')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (row.teamId === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.shooting?.match?.home_team?.name), 1))
                              : _createCommentVNode("", true),
                            (row.teamId === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(props.shooting?.match?.away_team?.name), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center", setAsRowActive('min')])
                }, _toDisplayString(getRowdata(row, "min")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center", setAsRowActive('pts')])
                }, _toDisplayString(getRowdata(row, "pts")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center", setAsRowActive('reb')])
                }, _toDisplayString(getRowdata(row, "reb")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center", setAsRowActive('ast')])
                }, _toDisplayString(getRowdata(row, "ast")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('blk')])
                }, _toDisplayString(getRowdata(row, "blk")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('stl')])
                }, _toDisplayString(getRowdata(row, "stl")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('fg')])
                }, _toDisplayString(getRowdata(row, "fg")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('3pt')])
                }, _toDisplayString(getRowdata(row, "3pt")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('ft')])
                }, _toDisplayString(getRowdata(row, "ft")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('oreb')])
                }, _toDisplayString(getRowdata(row, "oreb")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('dreb')])
                }, _toDisplayString(getRowdata(row, "dreb")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('tov')])
                }, _toDisplayString(getRowdata(row, "tov")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('at')])
                }, _toDisplayString(getRowdata(row, "at")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('pf')])
                }, _toDisplayString(getRowdata(row, "pf")), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["as-shooting__table-column as-text-center as-coulumn-show-full", setAsRowActive('+/-')])
                }, _toDisplayString(getRowdata(row, "+/-")), 3)
              ]))
            }), 128))
          ])
        ], 2),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"\"><div class=\"as-note\"><div class=\"as-note-item\"><span class=\"as-key\">MIN: </span><span class=\"as-value\">Thời gian ra sân</span></div><div class=\"as-note-item\"><span class=\"as-key\">PTS: </span><span class=\"as-value\">Điểm</span></div><div class=\"as-note-item\"><span class=\"as-key\">REB: </span><span class=\"as-value\">Bắt bóng bật bảng</span></div><div class=\"as-note-item\"><span class=\"as-key\">AST: </span><span class=\"as-value\">Đường chuyền kiến tạo</span></div><div class=\"as-note-item\"><span class=\"as-key\">BLK: </span><span class=\"as-value\">Chặn bóng</span></div><div class=\"as-note-item\"><span class=\"as-key\">STL: </span><span class=\"as-value\">Cướp bóng</span></div><div class=\"as-note-item\"><span class=\"as-key\">FG: </span><span class=\"as-value\">Chụp</span></div><div class=\"as-note-item\"><span class=\"as-key\">3PT: </span><span class=\"as-value\">Tỷ lệ 3 điểm</span></div><div class=\"as-note-item\"><span class=\"as-key\">FT: </span><span class=\"as-value\">Tỉ lệ ném phạt</span></div><div class=\"as-note-item\"><span class=\"as-key\">TOV: </span><span class=\"as-value\">Mất bóng</span></div><div class=\"as-note-item\"><span class=\"as-key\">OREB: </span><span class=\"as-value\">Bắt bóng bật bảng tấn công</span></div><div class=\"as-note-item\"><span class=\"as-key\">DREB: </span><span class=\"as-value\">Bắt bóng bật bảng phòng ngự</span></div><div class=\"as-note-item\"><span class=\"as-key\">A/T: </span><span class=\"as-value\">Đường chuyền kiến tạo/Mất bóng</span></div><div class=\"as-note-item\"><span class=\"as-key\">PF: </span><span class=\"as-value\">Lỗi cá nhân</span></div><div class=\"as-note-item\"><span class=\"as-key\">+/-: </span><span class=\"as-value\">Plus Minus</span></div></div></div>", 1))
      ]))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})